type Props = {
  expanded: boolean;
  onClick: () => void;
  className?: string;
};

/** Same ☰ control for sidebar expanded (collapse) and collapsed (reopen). */
export function WaveShellToggleButton({ expanded, onClick, className = "" }: Props) {
  return (
    <button
      type="button"
      className={`wave-shell-toggle-btn${className ? ` ${className}` : ""}`}
      aria-label={expanded ? "Comprimi menu" : "Apri menu"}
      aria-expanded={expanded}
      onClick={onClick}
    >
      <span className="wave-shell-toggle-icon" aria-hidden>
        ☰
      </span>
    </button>
  );
}
